"use client";
import { Modal } from "antd";
import styles from "./contact-section.module.scss";
import { useState } from "react";
import FormChatBotMobile from "../../dialog/form-chat-bot-mobile";
import _ from "lodash";
import { createCallLogs } from "@/src/app/phong-kham/[slug]/service-server";

const ContactSection = () => {
  const [isOpenModalConsulation, setIsOpenModalConsulation] = useState(false);

  const saveDataCall = async () => {
    const userAgent = navigator?.userAgent;
    const url = window?.location?.href;
    const params = {
      clinic_id: 63,
      to_phone_number: "0976654560",
      landing_page_url: localStorage?.getItem("firstVisitPage")
        ? localStorage?.getItem("firstVisitPage")
        : window?.location?.href,
      referrer: localStorage?.getItem("referrer")
        ? localStorage?.getItem("referrer")
        : "",
      user_agent: userAgent,
      url: url,
    };

    await createCallLogs(params);
  };
  const throttledHandleCallPhone = _.throttle(saveDataCall, 10000, {
    leading: true,
    trailing: false,
  });
  const handleCallPhone = async () => {
    window.open(`tel:0976654560`, "_self");
    await throttledHandleCallPhone()
  };

  return (
    <>
      <div className={styles.contactSection}>
        <button
          onClick={() => setIsOpenModalConsulation(true)}
          className={styles.contactBtn}
        >
          <p className={styles.contactBtnTitle}>NhaKhoaHub</p>
          <p className={styles.contactBtnContent}>Nhận tư vấn</p>
        </button>
        <a onClick={handleCallPhone} className={styles.contactBtn}>
          <p className={styles.contactBtnTitle}>NhaKhoaHub</p>
          <p className={styles.contactBtnContent}>Gọi 0976654560</p>
        </a>
      </div>
      <Modal
        className="modal-chatbot-mobile"
        open={isOpenModalConsulation}
        onCancel={() => {
          setIsOpenModalConsulation(false);
        }}
        footer={null}
        closable={true}
        width={380}
        destroyOnClose={true}
        centered
      >
        <FormChatBotMobile clinic={null} />
      </Modal>
    </>
  );
};

export default ContactSection;
